/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum JobMappingMode {
    GLOBAL = 'global',
    LOCAL = 'local',
    GLOBAL_AND_LOCAL = 'globalAndLocal',
}
